import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import SupervisedUserCircleOutlinedIcon from "@mui/icons-material/SupervisedUserCircleOutlined";
const routesConfig = [
    {
        id: "dashboard",
        title: "Dashboard",
        messageId: "sidebar.dashboard",
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        type: "item",
        icon: <GridViewOutlinedIcon sx={{ color: "#00455E" }} />,
        url: "/dashboard",
    },
    {
        id: "newsandupdate",
        title: "NewsAndUpdate",
        messageId: "sidebar.newsandupdates",
        permittedRole: [
            // RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            // RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            // RoutePermittedRole.HR_MANAGER,
            // RoutePermittedRole.FINANCE_MANAGER,
            // RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.KITCHEN,
            // RoutePermittedRole.ACCOMODATION,
        ],
        type: "item",
        icon: <NewspaperOutlinedIcon sx={{ color: "#00455E" }} />,
        url: "/news",
    },
    {
        id: "roombooking",
        title: "Room Booking",
        messageId: "sidebar.room",
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.LOCATION_MANAGER,
        ],
        type: "collapse",
        icon: <BedOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "roomrequest",
                title: "Room Booking",
                messageId: "sidebar.room.myRequest",
                permittedRole: [
                    // RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.MEMBER,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.DOCTOR,
                ],
                type: "item",
                url: "/room/booking-request",
            },
            {
                id: "pendingRequests",
                title: "Pending",
                permittedRole: [RoutePermittedRole.LOCATION_MANAGER],
                messageId: "sidebar.room.pendingRequest",
                type: "item",
                url: "/room/approval-request",
            },
            {
                id: "RoomAvailability",
                title: "Room Availability",
                permittedRole: [RoutePermittedRole.LOCATION_MANAGER],
                messageId: "sidebar.room.roomAvailability",
                type: "item",
                url: "/room/list",
            },
            {
                id: "frontdeskRequest",
                title: "FrontDesk Request",
                permittedRole: [RoutePermittedRole.FRONTDESK],
                messageId: "sidebar.room.userBooking",
                type: "item",
                url: "/room/frontdesk-request",
            },

            {
                id: "checkInUser",
                title: "CheckInUser",
                permittedRole: [
                    RoutePermittedRole.KITCHEN,
                    RoutePermittedRole.ACCOMODATION,
                ],
                messageId: "sidebar.room.checkInUser",
                type: "item",
                url: "/room/check-in-user",
            },
            {
                id: "roomlogs",
                title: "Logs",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.SETUP_MANAGER,
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.ACCOMODATION,
                    RoutePermittedRole.KITCHEN,
                ],
                messageId: "sidebar.room.roomlogs",
                type: "item",
                url: "/room/logs",
            },
        ],
    },
    {
        id: "leave",
        title: "Leave",
        messageId: "sidebar.leave",
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        type: "collapse",
        icon: <DateRangeOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "myRequests",
                title: "My Requests",
                messageId: "sidebar.leave.myRequests",
                permittedRole: [
                    RoutePermittedRole.MANAGER,
                    // RoutePermittedRole.ADMIN,
                    // RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.MEMBER,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.DOCTOR,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/leave/requests",
            },
            {
                id: "pendingRequests",
                title: "Pending Requests",
                messageId: "sidebar.leave.pending",
                permittedRole: [
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.ADMIN,
                    // RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.DOCTOR,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/leave/pending",
            },
            {
                id: "approvedRequests",
                title: "Approved Requests",
                messageId: "sidebar.leave.approved",
                permittedRole: [
                    RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.KITCHEN,
                    RoutePermittedRole.ACCOMODATION,
                ],
                type: "item",
                url: "/leave/approved",
            },
            {
                id: "leavelogs",
                title: "Leave Logs",
                messageId: "sidebar.leave.logs",
                permittedRole: [
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.DOCTOR,
                    RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.KITCHEN,
                    RoutePermittedRole.ACCOMODATION,
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/leave/logs",
            },
        ],
    },
    {
        id: "events",
        title: "Event",
        messageId: "sidebar.events",
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        type: "collapse",
        icon: <EventOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "events",
                title: "Events",
                messageId: "sidebar.events",
                permittedRole: [
                    RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.MEMBER,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.DOCTOR,
                    RoutePermittedRole.ACCOMODATION,
                    RoutePermittedRole.KITCHEN,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/event/upcoming",
            },
            {
                id: "panchang",
                title: "Panchang",
                messageId: "sidebar.panchang",
                permittedRole: [
                    RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.MEMBER,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.DOCTOR,
                    RoutePermittedRole.ACCOMODATION,
                    RoutePermittedRole.KITCHEN,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/event/panchang",
            },
        ],
    },
    {
        id: "attendance",
        title: "Attendance",
        messageId: "sidebar.attendance",
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        type: "collapse",
        icon: <CalendarMonthOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "attendance",
                title: "Create Requests",
                messageId: "sidebar.attendance.my",
                permittedRole: [
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.MEMBER,
                    RoutePermittedRole.DOCTOR,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/my-attendance",
            },
            {
                id: "myattendance",
                title: "My Attendance",
                messageId: "sidebar.attendance.all",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.HR_MANAGER,
                    // RoutePermittedRole.LOCATION_MANAGER
                ],
                type: "item",
                url: "/attendance",
            },
            {
                id: "myRequests",
                title: "My Requests",
                messageId: "sidebar.attendance.count",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.LOCATION_MANAGER,
                ],
                type: "item",
                url: "/present",
            },
        ],
    },
    {
        id: "issues",
        title: "issues",
        messageId: "sidebar.issues",
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.SETUP_MANAGER,
            // RoutePermittedRole.ACCOMODATION,
            // RoutePermittedRole.KITCHEN,
        ],
        type: "collapse",
        icon: <ReportProblemOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "createissue",
                title: " Create Issue",
                messageId: "sidebar.issue.createissue",
                permittedRole: [
                    // RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.MEMBER,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.DOCTOR,
                    // RoutePermittedRole.ACCOMODATION,
                    // RoutePermittedRole.KITCHEN,
                ],
                type: "item",
                url: "/issue/list",
            },
            {
                id: "issueApproval",
                title: "Issue Apporval",
                messageId: "sidebar.issue.issueApproval",
                permittedRole: [
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.FRONTDESK,
                    // RoutePermittedRole.MEMBER,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.DOCTOR,
                    // RoutePermittedRole.ACCOMODATION,
                    // RoutePermittedRole.KITCHEN,
                ],
                type: "item",
                url: "/issue/approval",
            },
            {
                id: "issueManagerLog",
                title: "Issue ManagerLog",
                messageId: "sidebar.issue.managerlog",
                permittedRole: [
                    RoutePermittedRole.LOCATION_MANAGER,
                    // RoutePermittedRole.MEMBER,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.DOCTOR,
                    // RoutePermittedRole.ACCOMODATION,
                    // RoutePermittedRole.KITCHEN,
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/issue/logs",
            },
            {
                id: "issueManagerEsclatedLog",
                title: "Escalated",
                messageId: "sidebar.issue.escalated",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/issue/escalated",
            },
            {
                id: "issueassigned",
                title: " Issue Assigned ",
                messageId: "sidebar.issue.issueassigned",
                permittedRole: [
                    // RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.MEMBER,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.FINANCE_MANAGER,
                    // RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.DOCTOR,
                    // RoutePermittedRole.ACCOMODATION,
                    // RoutePermittedRole.KITCHEN,
                ],
                type: "item",
                url: "/issue/assign",
            },
            {
                id: "categorylist",
                title: "Category List",
                messageId: "sidebar.issue.categorylist",
                permittedRole: [RoutePermittedRole.SUPER_ADMIN],
                type: "item",
                url: "/issue/category",
            },
        ],
    },
    {
        id: "performance",
        title: "Performance",
        messageId: "sidebar.performance",
        permittedRole: [
            // RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            // RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.FINANCE_MANAGER,
            // RoutePermittedRole.HR_MANAGER,
        ],
        type: "collapse",
        icon: <LeaderboardOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "performanceDashboard",
                title: "Dashboard",
                messageId: "sidebar.performance.dashboard",
                permittedRole: [
                    // RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.MEMBER,
                    // RoutePermittedRole.DOCTOR,
                    // RoutePermittedRole.FINANCE_MANAGER,
                    // RoutePermittedRole.HR_MANAGER,
                ],
                type: "item",
                url: "/performance/dashboard",
            },
            {
                id: "performanceGoal",
                title: "Goal",
                messageId: "sidebar.performance.goal",
                permittedRole: [
                    // RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.MEMBER,
                    // RoutePermittedRole.DOCTOR,
                    // RoutePermittedRole.FINANCE_MANAGER,
                    // RoutePermittedRole.HR_MANAGER,
                ],
                type: "item",
                url: "/performance/goal",
            },
            {
                id: "performanceProject",
                title: "Project",
                messageId: "sidebar.performance.project",
                permittedRole: [
                    // RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.MEMBER,
                    // RoutePermittedRole.DOCTOR,
                    // RoutePermittedRole.FINANCE_MANAGER,
                    // RoutePermittedRole.HR_MANAGER,
                ],
                type: "item",
                url: "/performance/project",
            },
        ],
    },
    {
        id: "srm",
        title: "SRM",
        messageId: "sidebar.crm",
        permittedRole: [
            // RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            // RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.FINANCE_MANAGER,
            // RoutePermittedRole.HR_MANAGER,
        ],
        type: "collapse",
        icon: <ManageAccountsOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "persons",
                title: "Persons",
                messageId: "sidebar.crm.persons",
                permittedRole: [
                    // RoutePermittedRole.FRONTDESK,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.MEMBER,
                    // RoutePermittedRole.DOCTOR,
                    // RoutePermittedRole.FINANCE_MANAGER,
                    // RoutePermittedRole.HR_MANAGER,
                ],
                type: "item",
                url: "/crm/client-list",
            },
            {
                id: "Approval",
                title: "Approval",
                messageId: "sidebar.crm.approval",
                permittedRole: [
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.FINANCE_MANAGER,
                ],
                type: "item",
                url: "/crm/approval",
            },
            {
                id: "RequestLogs",
                title: "RequestLogs",
                messageId: "sidebar.crm.requestLogs",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.FINANCE_MANAGER,
                ],
                type: "item",
                url: "/crm/logs",
            },
        ],
    },
    {
        id: "feedback",
        title: "feedback",
        messageId: "sidebar.feedback",
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
        type: "collapse",
        icon: <ManageAccountsOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "createfeedback",
                title: "createfeedback",
                messageId: "sidebar.feedback.feedbacks",
                permittedRole: [RoutePermittedRole.SUPER_ADMIN],
                type: "item",
                url: "/feedback",
            },
            {
                id: "userFeedback",
                title: " userFeedback",
                messageId: "sidebar.feedback.userFeedback",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                ],
                type: "item",
                url: "/feedback-response",
            },
            {
                id: "areamaster",
                title: "areamaster",
                messageId: "sidebar.feedback.areaMaster",
                permittedRole: [RoutePermittedRole.SUPER_ADMIN],
                type: "item",
                url: "/feedback-area-master",
            },
        ],
    },
    {
        id: "sos",
        title: "sos",
        messageId: "sidebar.sos",
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
        ],
        type: "item",
        icon: <ManageAccountsOutlinedIcon sx={{ color: "#00455E" }} />,
        url: "/sos/sos-list",
    },
    {
        id: "reports",
        title: "reports",
        messageId: "sidebar.reports",
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FINANCE_MANAGER,
        ],
        type: "collapse",
        icon: <ManageAccountsOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "issue",
                title: "issue",
                messageId: "sidebar.reports.issue",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.SETUP_MANAGER,
                    RoutePermittedRole.MANAGER,
                ],
                type: "item",
                url: "/reports/issue-report",
            },
            {
                id: "attendance",
                title: "attendance",
                messageId: "sidebar.reports.attendance",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.SETUP_MANAGER,
                    RoutePermittedRole.MEMBER,
                ],
                type: "item",
                url: "/reports/attendance-report",
            },
            {
                id: "leave",
                title: "leave",
                messageId: "sidebar.reports.leave",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.HR_MANAGER,
                    RoutePermittedRole.DOCTOR,
                    RoutePermittedRole.FINANCE_MANAGER,
                    RoutePermittedRole.MANAGER,
                    RoutePermittedRole.MEMBER,
                ],
                type: "item",
                url: "/reports/leave-report",
            },
            {
                id: "roomBooking",
                title: "Room Booking",
                messageId: "sidebar.reports.roomBooking",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/reports/room-booking-report",
            },
            {
                id: "feedback",
                title: "feedback",
                messageId: "sidebar.reports.feedback",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/reports/feedback-report",
            },
            {
                id: "birthday",
                title: "birthday",
                messageId: "sidebar.reports.birthday",
                permittedRole: [
                    RoutePermittedRole.ADMIN,
                    RoutePermittedRole.SUPER_ADMIN,
                    RoutePermittedRole.LOCATION_MANAGER,
                    RoutePermittedRole.SETUP_MANAGER,
                ],
                type: "item",
                url: "/reports/birthday-report",
            },
        ],
    },
    {
        id: "master",
        title: "Master",
        messageId: "sidebar.master",
        permittedRole: [RoutePermittedRole.SUPER_ADMIN],
        type: "collapse",
        icon: <ManageAccountsOutlinedIcon sx={{ color: "#00455E" }} />,
        children: [
            {
                id: "user",
                title: "User Management",
                permittedRole: [RoutePermittedRole.SUPER_ADMIN],
                messageId: "sidebar.master.user",
                type: "item",
                icon: (
                    <SupervisedUserCircleOutlinedIcon
                        sx={{ color: "#00455E" }}
                    />
                ),
                url: "/master/user",
            },
            {
                id: "department",
                title: "Department",
                permittedRole: [RoutePermittedRole.SUPER_ADMIN],
                messageId: "sidebar.master.department",
                type: "item",
                icon: (
                    <SupervisedUserCircleOutlinedIcon
                        sx={{ color: "#00455E" }}
                    />
                ),
                url: "/master/department",
            },
            {
                id: "locationAuthorities",
                title: "Location Authorities",
                permittedRole: [RoutePermittedRole.SUPER_ADMIN],
                messageId: "sidebar.master.locationAuthorities",
                type: "item",
                icon: (
                    <SupervisedUserCircleOutlinedIcon
                        sx={{ color: "#00455E" }}
                    />
                ),
                url: "/master/location-authorities",
            },
        ],
    },
];
export default routesConfig;
